import styled from "styled-components";

export const StarRatingContainer = styled.div`
  margin-bottom: 10px;

  .stars-container {
    display: flex;
    gap: 2px;
    justify-content: center;
    align-items: center;
  }
`;

export const StyledStar = styled.span<{ $fillPercentage: number }>`
  display: inline-block;
  position: relative;
  transition: all 0.2s ease;

  .star-clip {
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    width: ${({ $fillPercentage }) => `${$fillPercentage * 100}%`};
    height: 100%;
    transition: width 1.5s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;
